var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var dataState = {
    extract: {
        taskId: undefined,
        selectId: '',
        clickShape: {
            status: false,
            id: '',
        },
        data: {
            tieImages: [],
            tieDocContents: [],
            tieInfo: {},
            sequenct: [],
            calcuJson: [],
            listJson: [],
            drawJson: [],
            tableJson: [],
            tableListJson: {},
            extractSeq: [],
            llmSeq: [],
            llmTieInfo: {},
            llmTieTableInfo: {},
        },
        wordSelection: {
            show: false,
            showOptionList: false,
            tableSelected: {
                tableKey: '',
                tableId: '',
                lineKey: '',
                lineName: '',
                lineIndex: 0,
            },
            pageNum: null,
            words: '',
            wordsShapeId: [],
            activeShapeId: '',
            field: '',
            type: 'normal',
        },
        status: null,
        progress: '',
        traceId: null,
    },
    attachment: [],
    history: {
        historyList: [],
        delId: 0,
    },
    responseData: null,
    loadingProgress: '文档信息提取中，请稍候......',
};
export function dataReducer(state, action) {
    if (state === void 0) { state = dataState; }
    var payload = action.payload;
    switch (action.type) {
        case 'init':
            return __assign(__assign({}, state), dataState);
        case 'changeExtractData':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), payload) });
        case 'updateProgress':
            return __assign(__assign({}, state), { loadingProgress: payload });
        case 'changeAttachmentList':
            return __assign(__assign({}, state), { attachment: payload });
        case 'changeHistoryList':
            return __assign(__assign({}, state), { history: __assign(__assign({}, state.history), { historyList: payload }) });
        case 'setDeleteHistoricalDetailId':
            return __assign(__assign({}, state), { history: __assign(__assign({}, state.history), { delId: payload }) });
        case 'doDeleteHistorical':
            return __assign(__assign({}, state), { history: __assign(__assign({}, state.history), { historyList: state.history.historyList
                        .filter(function (item) { return item.id !== state.history.delId; })
                        .map(function (item, index) {
                        return __assign({}, item);
                    }), delId: 0 }) });
        case 'changeSelectId':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { selectId: payload }) });
        case 'clickShape':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { clickShape: {
                        status: !state.extract.clickShape.status,
                        id: payload,
                    } }) });
        case 'setWordSelection':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { wordSelection: __assign(__assign({}, state.extract.wordSelection), payload) }) });
        case 'saveDrawBindListJson':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { listJson: state.extract.data.listJson.map(function (item) {
                            if (item.key === payload.key) {
                                return __assign(__assign({}, item), { drawData: payload.data, selectType: payload.type, select: payload.extractId, value: payload.value, confidence: payload.confidence });
                            }
                            else {
                                return item;
                            }
                        }), drawJson: state.extract.data.drawJson
                            .filter(function (item) {
                            return item.extractId !==
                                state.extract.data.listJson.find(function (list) { return list.key === payload.key; }).select;
                        })
                            .map(function (drawJsonItem) {
                            if (payload.data.find(function (item) { return item.shapeId === drawJsonItem.shapeId; })) {
                                return payload.data.find(function (item) { return item.shapeId === drawJsonItem.shapeId; });
                            }
                            else {
                                return drawJsonItem;
                            }
                        }) }) }) });
        case 'saveDrawBindTableListJson':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { tableListJson: payload.cloneTable, drawJson: state.extract.data.drawJson
                            .filter(function (item) {
                            return (item.extractId !== payload.lastDrawDataId && item.extractId);
                        })
                            .concat(payload.drawData) }) }) });
        case 'saveDrawBindLlmTableListJson':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { llmTableListJson: payload.cloneLlmTable, drawJson: state.extract.data.drawJson
                            .filter(function (item) {
                            return (item.extractId !== payload.lastDrawDataId && item.extractId);
                        })
                            .concat(payload.drawData) }) }) });
        case 'setDrawJson':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { drawJson: payload }) }) });
        case 'setTableInfo':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { tableListJson: payload }) }) });
        case 'setLlmTableInfo':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { llmTableListJson: payload }) }) });
        case 'hiddenTableUnit':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { tableJson: payload }) }) });
        case 'hiddenLlmTableUnit':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { llmTableJson: payload }) }) });
        case 'listJsonSelect':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { listJson: state.extract.data.listJson.map(function (item) {
                            if (item.key === payload.key) {
                                return __assign(__assign({}, item), { value: payload.value, select: payload.select, selectType: payload.selectType, confidence: payload.confidence });
                            }
                            else {
                                return item;
                            }
                        }) }) }) });
        case 'responseData':
            return __assign(__assign({}, state), { responseData: payload });
        case 'changeF7Currency':
            return __assign(__assign({}, state), { extract: __assign(__assign({}, state.extract), { data: __assign(__assign({}, state.extract.data), { drawJson: state.extract.data.listJson.find(function (item) { return item.key === payload.key; })
                            .selectType === 'drawJson'
                            ? state.extract.data.drawJson.filter(function (item) {
                                return item.extractId !==
                                    state.extract.data.listJson.find(function (item) { return item.key === payload.key; }).select;
                            })
                            : state.extract.data.drawJson, listJson: state.extract.data.listJson.map(function (item) {
                            if (item.key === payload.key) {
                                return __assign(__assign({}, item), { value: payload.value, select: payload.select, selectType: payload.selectType, confidence: payload.confidence });
                            }
                            else {
                                return item;
                            }
                        }) }) }) });
        default:
            return state;
    }
}
